import { Grid } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import NavigationDrawer from "../../../components/NavigationDrawer";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import AddUsers from "./AddUsers";
import UserLists from "./UserLists";
import UserReviews from "./UserReviews";

const tabs = [
  { label: "Clients list", value: "clientList" },
  { label: "Reviews", value: "clientReviews" },
];

function ClientUsers() {
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state.activeTab.tabs);
  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, clientUsers: tab }));
  };

  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={"Clients*"}
            tabs={tabs}
            activeTab={activeTab.clientUsers}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {activeTab.clientUsers === "clientList" ? (
            <UserLists />
          ) : activeTab.clientUsers === "clientReviews" ? (
            <UserReviews />
          ) : activeTab.clientUsers === "addClients" ? (
            <AddUsers />
          ) : null}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default ClientUsers;
